import React, { useState, useEffect } from "react";
import api from "@api";
import { Form } from "@components";
import { SalesforceProfileModel } from "@api/types/salesforceprofile";
import { SalesforceProfileDetail } from "./detail";
import { M_TABLE_HEADERS_SALESFORCE_PROFILE } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { useSalesforceProfileStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportSalesforceProfiles } from "@api/excel-exporters/exportSalesforceProfiles";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_SALESFORCE_PROFILE.PROFILE_NAME },
  { data: M_TABLE_HEADERS_SALESFORCE_PROFILE.USER_TYPE },
  { data: M_TABLE_HEADERS_SALESFORCE_PROFILE.IS_ACTIVE },
];

export const SalesforceProfile: React.FC = () => {
  const [
    salesforceProfileStore,
    setSalesforceProfileStore,
  ] = useSalesforceProfileStore();

  useEffect(() => {
    if (salesforceProfileStore.fetchList) {
      getDataList();
    }
  }, [salesforceProfileStore]);

  const form = Form.useManager<SalesforceProfileModel>({
    id: 0,
    profileName: "",
    userType: "",
    isActive: true,
  });

  const [openSalesforce, setOpenSalesforceProfile] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedSalesforceProfile, setSelectedSalesforceProfile] = useState<
    SalesforceProfileModel
  >();
  const [salesforceprofileList, setSalesforceProfileList] = useState([]);

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (openSalesforce) {
      if (selectedSalesforceProfile) {
        form.set(Form.target.VALUE, ["id", selectedSalesforceProfile.id]);
        form.set(Form.target.VALUE, [
          "profileName",
          selectedSalesforceProfile.profileName,
        ]);
        form.set(Form.target.VALUE, [
          "userType",
          selectedSalesforceProfile.userType,
        ]);
        form.set(Form.target.VALUE, [
          "isActive",
          selectedSalesforceProfile.isActive,
        ]);
      }
    }
  }, [openSalesforce]);

  function getDataList() {
    api.salesforceprofile
      .getSalesforceProfile()
      .then((response) => {
        console.log(response.salesforceProfiles);
        setSalesforceProfileList(response.salesforceProfiles);
      })
      .catch((error) => {
        console.error(`Error in fetching salesforce profile ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        setSalesforceProfileStore({ fetchList: false });
      });
  }

  const isShowModal = openSalesforce ? (
    <SalesforceProfileDetail
      form={form}
      open={openSalesforce}
      onCancel={() => setOpenSalesforceProfile(false)}
    />
  ) : (
    ""
  );

  function handleExport() {
    exportSalesforceProfiles();
  }

  const pageName = "Salesforce Profiles";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={salesforceprofileList.map((profile: any) => ({
          cells: [
            {
              data: profile.profileName,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedSalesforceProfile(profile);
                setOpenSalesforceProfile(true);
              },
            },
            {
              data: profile.userType,
            },
            {
              data: profile.isActive ? "Yes" : "No",
            },
          ],
          data: profile,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_SALESFORCE_PROFILE.PROFILE_NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_SALESFORCE_PROFILE_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
